module.exports = __webpack_public_path__ + "static/media/carreta.0d3834e7.svg";